import React from 'react'
import { Check, ChevronDown, ArrowRight } from 'react-feather'
import { SegmentType } from 'src/lib/types/segment'
import { useLocale } from 'src/lib/hooks/useLocal'

interface CSVColumnMappingProps {
  segmentType: SegmentType
}

interface ColumnMappingRowProps {
  sourceColumn: string
  targetColumn: string
}

const ColumnMappingRow: React.FC<ColumnMappingRowProps> = ({ sourceColumn, targetColumn }) => {
  return (
    <div className='flex items-center gap-1.5 w-full'>
      {/* Source Column (from CSV) */}
      <div className='flex-1 h-9 px-3 flex items-center bg-gray-100 rounded-lg shadow-[0px_0px_0px_1px_rgba(106,114,130,0.2)]'>
        <span className='text-text-sm-regular text-coal-dark opacity-60'>{sourceColumn}</span>
      </div>

      {/* Arrow */}
      <div className='flex items-center justify-center w-4 h-4'>
        <ArrowRight size={14} className='text-gray-400' />
      </div>

      {/* Target Column (mapped to) */}
      <div className='flex-1 h-9 px-3 flex items-center justify-between bg-white rounded-lg shadow-[0px_0px_0px_1px_rgba(106,114,130,0.24),0px_1px_3px_0px_rgba(26,26,26,0.08)]'>
        <span className='text-text-sm-regular text-coal-dark'>{targetColumn}</span>
        <ChevronDown size={16} className='text-gray-500' />
      </div>
    </div>
  )
}

const CSVColumnMapping: React.FC<CSVColumnMappingProps> = ({ segmentType }) => {
  const { t } = useLocale()

  const mappings =
    segmentType === 'PHONE_NUMBER'
      ? [{ source: t('segment_creation.numbers_column'), target: t('segment_creation.phone_number_column') }]
      : [{ source: t('segment_creation.pincodes_column'), target: t('segment_creation.pincode_column') }]

  return (
    <div className='flex flex-col gap-3 pt-3'>
      {/* Success Message */}
      <div className='flex items-center gap-1'>
        <div className='flex items-center justify-center w-4 h-4'>
          <Check size={14} className='text-[#5EA500]' />
        </div>
        <span className='text-text-xs-medium text-[#5EA500]'>{t('segment_creation.matched_columns_success')}</span>
      </div>

      {/* Column Mappings */}
      <div className='flex flex-col gap-3'>
        {mappings.map((mapping, index) => (
          <ColumnMappingRow key={index} sourceColumn={mapping.source} targetColumn={mapping.target} />
        ))}
      </div>
    </div>
  )
}

export default CSVColumnMapping
